import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageLoader from '../../../components/loaders/PageLoader';
import { GET } from '../../../services/rest.service';

const Dashboard = () => {
  const [totalSkills, setTotalSkills] = useState(0);
  const [familyCount, setFamilyCount] = useState(0);
  const [totalNannies, setTotalNannies] = useState(0);
  const [totalNannyRequest, setTotalNannyRequest] = useState(0);
  const [totalSitterRequest, setTotalSitterRequest] = useState(0);
  const [totalJobListings, setTotalJobListings] = useState(0);
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();

  const getStats = async () => {
    try {
      const { data } = await GET('/admin/get/stats');
      setTotalSkills(data.totalSkills);
      setFamilyCount(data.familyCount);
      setTotalNannies(data.totalNannies);
      setTotalNannyRequest(data.totalNannyRequest);
      setTotalSitterRequest(data.totalSitterRequest);
      setTotalJobListings(data.totalJobListings);
      setIsReady(true);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  if (!isReady) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row mb-4">
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer" onClick={() => navigate('/admin/nanny/list')}>
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-violet"></div>
                <div className="text">
                  <h6 className="mb-0">Total Nannies</h6>
                  <span className="text-gray">{totalNannies}</span>
                </div>
              </div>
              <div className="icon text-white bg-violet">
                <i className="fas fa-server"></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer" onClick={() => navigate('/admin/postings/list')}>
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-yellow"></div>
                <div className="text">
                  <h6 className="mb-0">Total Job Listings</h6>
                  <span className="text-gray">{totalJobListings}</span>
                </div>
              </div>
              <div className="icon text-white bg-yellow">
                <i className="fas fa-server"></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer" onClick={() => navigate('/admin/skills/list')}>
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-green"></div>
                <div className="text">
                  <h6 className="mb-0">Skills Added</h6>
                  <span className="text-gray">{totalSkills}</span>
                </div>
              </div>
              <div className="icon text-white bg-green">
                <i className="far fa-clipboard"></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer" onClick={() => navigate('/admin/family/list')}>
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-blue"></div>
                <div className="text">
                  <h6 className="mb-0">Families Registered</h6>
                  <span className="text-gray">{familyCount}</span>
                </div>
              </div>
              <div className="icon text-white bg-blue">
                <i className="fa fa-dolly-flatbed"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer" onClick={() => navigate('/admin/requests/nanny')}>
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-red"></div>
                <div className="text">
                  <h6 className="mb-0">New Nanny Request(s)</h6>
                  <span className="text-gray">{totalNannyRequest}</span>
                </div>
              </div>
              <div className="icon text-white bg-red">
                <i className="fas fa-receipt"></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 mb-4 mb-xl-0 c-pointer" onClick={() => navigate('/admin/requests/sitter')}>
            <div className="bg-white shadow roundy p-4 h-100 d-flex align-items-center justify-content-between">
              <div className="flex-grow-1 d-flex align-items-center">
                <div className="dot mr-3 bg-violet"></div>
                <div className="text">
                  <h6 className="mb-0">New Sitter Request(s)</h6>
                  <span className="text-gray">{totalSitterRequest}</span>
                </div>
              </div>
              <div className="icon text-white bg-violet">
                <i className="fas fa-server"></i>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
